// 移动端语音消息
import React from "react";
import classNames from "classnames";
import { confirmPlatfrom, postMessageData } from "@/helper";
import ReactDOM from "react-dom";
import Toast from "@/components/toast/toast";
import * as Event from "@/event/message_events";
import { sendMessage, sendLog } from "@/api/index";

class SingleMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
    };
  }
  render() {
    const { message, style } = this.props;
    const { playing } = this.state;
    let type = message.message_type;

    if (type === "loading") {
      return (
        <div className="ms-record loading">
          <i className="loading-icon" />
        </div>
      );
    } else if (
      type === "failure" ||
      /\.(wav|aac|mp3)$/.test(message.content.trim())
    ) {
      const fileLength = message.fileLength || message.file_length;
      return (
        <div
          className={classNames(
            "ms-record",
            { playing: playing },
            { failure: type === "failure" }
          )}
          data-time={fileLength ? `${Math.round(fileLength)}"` : null}
          style={style}
          onClick={(e) => this.playRecord()}
        >
          {type === "failure" ? (
            <i className="failure-icon" onClick={(e) => this.reUploadAudio(e)}>
              重发
            </i>
          ) : null}
        </div>
      );
    } else if (
      /\!\[image\]/.test(message.content) ||
      /\!\[url\]/.test(message.content)
    ) {
      return <Content content={this._assembleTem(message.content)} />;
    } else if (/\/scratch\#/.test(message.content)) {
      return <Content content={"【向老师发送了工程文件求助】"} />;
    } else {
      return <Content content={message.content} />;
    }
  }

  componentDidMount() {
    const { message } = this.props;
    const type = message.message_type;
    if (
      (message.content && /\.(wav|aac|mp3)$/.test(message.content.trim())) ||
      type === "loading"
    ) {
      Event.bus.on(Event.PLAYFINISH, (src) => {
        if (!src || this.props.message.content !== src) {
          this.finishPlay();
        }
      });
    }
  }
  //播放音频
  playRecord() {
    const { message } = this.props;
    const { playing } = this.state;
    if (message.message_type === "failure") {
      if (!playing) {
        //阿里云上传未成功，原生播放
        window.bridge.playIMAudioRecord({
          params: { id: message.voiceId },
          success: () => {
            console.log("原生端播放结束，调用success");
            this.setState({
              playing: false,
            });
          },
          fail: () => {},
        });
      } else {
        window.bridge.stopPlayIMAudioRecord({
          params: { id: message.voiceId },
          success: () => {},
          fail: () => {},
        });
      }
      this.setState({
        playing: !playing,
      });
      return;
    }
    Event.bus.emit(Event.PLAY, message.content);
    this.setState({
      playing: true,
    });
  }
  reUploadAudio(e) {
    e.preventDefault();
    e.stopPropagation();
    const { message } = this.props;
    console.log("message.voiceId:", message);
    window.bridge.retryUploadIMAudioRecord({
      params: { id: message.voiceId },
      success: (succParam) => {
        if (confirmPlatfrom() === "ios") {
          succParam = JSON.parse(succParam);
        }
        console.log("retry_succParam：", succParam);
        const newMessage = {
          message: {
            file_length: message.fileLength || message.file_length,
            message_type: "audio",
            message_content_type: "audio",
            message: "",
            fromMe: true,
            content: succParam.url,
            voiceId: message.voiceId,
          },
        };
        this.sendAudioMessage(succParam.url, newMessage.message);
      },
      fail: (failParam) => {
        if (confirmPlatfrom() === "ios") {
          failParam = JSON.parse(failParam);
        }
        console.log("retry_failParam：", failParam);
        this.addToast("重发失败", 2000);
      },
    });
  }

  // 发送语音消息
  sendAudioMessage(content, message) {
    return new Promise(() => {
      this.sendMessage(content, "audio", message);
    });
  }
  //发送消息
  sendMessage(content, type, message) {
    const { data, $updateMessage } = this.props;
    const formData = this.formData(content, data, type, message);
    this.ajaxSendMessage(formData, type)
      .then((res) => {
        res.data.message.voiceId = message.voiceId;
        // 更新消息列表
        $updateMessage(res);
      })
      .catch((e) => {
        sendLog(formData);
        console.error(`发送消息失败：${e}`);
      });
  }
  // ajax发送消息
  ajaxSendMessage(formData) {
    return new Promise((resolve, reject) => {
      sendMessage(formData)
        .then((res) => {
          const result = {
            online: res.online,
            message: res,
          };
          resolve(result);
        })
        .catch(reject);
    });
    // return new Promise((resolve, reject) => {
    //   Axios.post(ApiUri.MESSAGES, formData)
    //     .then(res => {
    //       if (res.status === 200) {
    //         resolve(res);
    //       } else {
    //         reject(res);
    //       }
    //     })
    //     .catch((err, msg) => {
    //       reject(err, msg);
    //     });
    // });
  }

  formData(content, data, type, message) {
    const postData = postMessageData(data, {
      message: content,
      message_content_type: type,
      file_length: message && message.file_length,
    });
    return postData;
  }

  addToast(content, duration) {
    let toastDiv = document.createElement("div");
    let div = document.querySelector(".dl-wrapper");
    if (!div) return;
    div.appendChild(toastDiv);
    ReactDOM.render(<Toast content={content} />, toastDiv);

    this.timer = setTimeout(() => {
      ReactDOM.unmountComponentAtNode(toastDiv);
      div.removeChild(toastDiv);
    }, duration);
  }
  // 拼装模板
  _assembleTem(content) {
    content = this._replaceUrl(content, "link");
    content = this._replaceUrl(content, "img");
    return content;
  }

  // 匹配资源地址
  _matchSrc(content) {
    const reg = /\([^\(]*\)/g;
    let arr = content.match(reg);
    if (arr) {
      return content.match(reg).map((url) => {
        return url.replace(/[\(|\)]/g, "");
      });
    }
  }
  // 替换资源地址
  _replaceUrl(content, type) {
    const { resize } = this.props.data;
    let replaceUrl = /\!\[url\]\([^\(]*\)/g;
    let replaceImg = /\!\[image\]\([^\(]*\)/g;
    const srcs = this._matchSrc(content);
    if (!srcs) {
      return content;
    }
    content = content.replace(
      type === "img" ? replaceImg : replaceUrl,
      "[placeholder]"
    );
    content = content.trim();
    srcs.map((src) => {
      content = content.replace(
        "[placeholder]",
        type === "img"
          ? `<img src=${src + resize} alt=""/>`
          : `<a href=${src} class="ms-answer">${src}</a>`
      );
    });
    return content;
  }

  finishPlay() {
    setTimeout(() => {
      this.setState({
        playing: false,
      });
    }, 0);
  }
}

function Content(props) {
  const { content } = props;
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      style={{ wordBreak: "break-all" }}
    ></div>
  );
}
export default SingleMessage;
